export var EventRegistrationEntity = {
    EntityName: "msevtmgt_eventregistration",
    EntitySetName: "msevtmgt_eventregistrations",
    FieldName_Name: "msevtmgt_name",
    FieldName_Id: "msevtmgt_eventregistrationid",
    FieldName_EventId: "msevtmgt_eventid",
    FieldName_ContactId: "msevtmgt_contactid",
    RelationShip_Contact: "msevtmgt_contact_msevtmgt_eventregistration_Contact"
};
